import { useMemo, useState } from "react";

import { Header } from "components/elements";

import { TiVoTargetsListProps } from "../types";
import { useTiVoDeviceData } from "../useTiVoDeviceData";
import { TargetScrollList } from "./TargetScrollList";
import styles from "./TargetSearchList.scss";

export function TargetSearchList({
  listName,
  label,
  items,
  restrictTargets,
  enableSlugBulkSelection,
  dataTestId = "target-search",
}: TiVoTargetsListProps) {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { getDeviceLabel } = useTiVoDeviceData();
  const listGroups = useMemo(() => Object.keys(items), [items]);

  const filteredItems: Record<string, string[]> = useMemo(() => {
    if (!searchTerm || !items) {
      return items || {};
    }
    return listGroups.reduce((result: typeof items, key) => {
      const filtered = items[key].filter((option) =>
        getDeviceLabel(option).toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (filtered.length) {
        result[key] = filtered;
      }
      return result;
    }, {});
  }, [getDeviceLabel, items, listGroups, searchTerm]);

  return (
    <div data-test-id={dataTestId}>
      <Header uppercase color={"tertiary"} type={"h6"}>
        {label}
      </Header>
      {filteredItems && (
        <>
          <div className={styles.searchInput}>
            <input
              placeholder={"Search"}
              type="text"
              value={searchTerm}
              data-test-id={`${dataTestId}-input`}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
            />
          </div>
          <TargetScrollList
            label={label}
            listName={listName}
            items={items}
            filteredItems={filteredItems}
            restrictTargets={restrictTargets}
            enableSlugBulkSelection={enableSlugBulkSelection}
            dataTestId={`${dataTestId}-list`}
          />
        </>
      )}
    </div>
  );
}
